// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login-widget_wrapper__3aW2Q","inputField":"login-widget_inputField__zI1hU","passwordInput":"login-widget_passwordInput__3XwQ9"};